import { Navigate, Outlet } from "react-router-dom";
import { isAccessTokenStored } from "../services/auth.service";

const SemiProtectedRoute = () => {
  const auth = isAccessTokenStored();
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default SemiProtectedRoute;
